import PropTypes from "prop-types";
import React from "react";
import { Query } from "react-apollo";
import { GET_RECIPIENT_USERS_QUERY } from "../../../../graphql/query/ConversationQuery";
import Loader from "../../../layout/Loader";
import SendMessageSelectRecipientItem from "./SendMessageSelectRecipientItem";
import { BRAND_COLOURS } from "../../../../constants";

type Props = {
    institution;
    selectParticipant;
    recipients;
    validation;
};
class SendMessageSelectRecipients extends React.Component<Props> {
    static propTypes = {
        institution: PropTypes.object
    };
    render() {
        const {
            institution,
            selectParticipant,
            recipients,
            validation
        } = this.props;

        let validationText =
            typeof validation !== "undefined" ? validation.message : null;

        return (
            <React.Fragment>
                <style jsx>
                    {`
                        .error {
                            color: ${BRAND_COLOURS.danger};
                        }
                        .recipients-list {
                            vertical-align: top;
                        }
                    `}
                </style>
                <div className={"recipients-list"}>
                    <Query
                        query={GET_RECIPIENT_USERS_QUERY}
                        variables={{
                            institution_id: institution.id
                        }}
                    >
                        {({ data, loading }) => {
                            if (loading) {
                                return <Loader />;
                            }

                            if (data && data.users.length <= 0) {
                                return (
                                    <p>
                                        No users are available for messaging at
                                        this institution.
                                    </p>
                                );
                            }

                            if (data && data.users) {
                                return data.users.map((user) => (
                                    <SendMessageSelectRecipientItem
                                        key={user.id}
                                        user={user}
                                        recipients={recipients}
                                        selectParticipant={selectParticipant}
                                    />
                                ));
                            }

                            return <p>An error occurred...</p>;
                        }}
                    </Query>
                </div>
                {validationText && (
                    <div className={"mt-2 error"}>{validationText}</div>
                )}
            </React.Fragment>
        );
    }
}

export default SendMessageSelectRecipients;
